import { createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22c69cfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "middle" }
const _hoisted_4 = {
  key: 0,
  class: "manga-list"
}
const _hoisted_5 = { class: "touch-dom" }
const _hoisted_6 = {
  key: 1,
  class: "chapter-list"
}
const _hoisted_7 = { class: "touch-dom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["tabs"], {
        modelValue: $setup.collectType,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.collectType) = $event)),
        items: $setup.items,
        onChange: $setup.tabs_change
      }, null, 8 /* PROPS */, ["modelValue", "items"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createCommentVNode(" 加载骨架屏 "),
      ($setup.loading)
        ? (_openBlock(), _createBlock($setup["listSkeleton"], { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            ($setup.collectType === 'manga')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['manga-list-box', { block: $setup.config.viewType === 'list' }])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (i, k) => {
                        return (_openBlock(), _createBlock($setup["manga"], {
                          key: k,
                          viewType: $setup.config.viewType,
                          mangaInfo: i,
                          onContextmenu: _withModifiers(($event: any) => ($setup.context_menu(i, k)), ["prevent"])
                        }, null, 8 /* PROPS */, ["viewType", "mangaInfo", "onContextmenu"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 2 /* CLASS */)
                  ]),
                  _createCommentVNode("分页组件"),
                  _createVNode($setup["mediaPager"], {
                    ref: "pager",
                    page: $setup.page,
                    count: $setup.count,
                    "page-size-config": $setup.pageSizes,
                    onPageChange: $setup.page_change
                  }, null, 8 /* PROPS */, ["page", "count", "page-size-config"])
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.collectType === 'chapter')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createCommentVNode("章节列表"),
                    _createElementVNode("div", {
                      class: _normalizeClass(['chapter-list-box', { block: $setup.config.viewType === 'list' }])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (i, k) => {
                        return (_openBlock(), _createBlock($setup["chapter"], {
                          key: k,
                          "view-type": $setup.config.viewType,
                          chapterInfo: i,
                          onClick: ($event: any) => ($setup.go_browse(i)),
                          onContextmenu: _withModifiers(($event: any) => ($setup.context_menu(i, k)), ["prevent"])
                        }, null, 8 /* PROPS */, ["view-type", "chapterInfo", "onClick", "onContextmenu"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 2 /* CLASS */)
                  ]),
                  _createCommentVNode("分页组件"),
                  _createVNode($setup["mediaPager"], {
                    ref: "pager",
                    page: $setup.page,
                    count: $setup.count,
                    "page-size-config": $setup.pageSizes,
                    onPageChange: $setup.page_change
                  }, null, 8 /* PROPS */, ["page", "count", "page-size-config"])
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
    ])
  ]))
}